export default Object.freeze({
    PROCESSLIST : "ProcessList",
    FORMLIST : "FormList",
    DATATABLES : "DataTables_",
    PROCESSTYPE : "_processType",
    PROCESSNAME : "_processName",
    SELECTEDAPPLICATION : "_selectedApplication",
    PROCESSLISTPAGESIZE : "ProcessListPageSize",
    FORMLISTPAGESIZE : "FormListPageSize",
    FORMTYPE : "_formType",
    FORMNAME : "_formName"
  })